const { REACT_APP_API } = process.env;
export const TOP_RATED = `https://api.themoviedb.org/3/movie/popular?api_key=${REACT_APP_API}&page=1`;
